const baseUrl = "https://autoembed.xyz";
export default{
    generateMovieUrl:(id)=>{
        let finalUrl = `${baseUrl}/movie/tmdb/${id}`;
        return finalUrl
    },
    generateEpisodeUrl:(serieId, seasonNumber, episodeNumber)=>{
        let finalUrl = `${baseUrl}/tv/tmdb/${serieId}-${seasonNumber}-${episodeNumber}`;
        return finalUrl
    }
}